<script setup lang="ts">
import {
  AccordionContent,
  AccordionContentProps,
  useForwardProps,
} from 'radix-vue'

const props = defineProps<AccordionContentProps>()
const forwarded = useForwardProps(props)
</script>

<template>
  <AccordionContent
    v-bind="forwarded"
    class="accordion-content"
  >
    <slot></slot>
  </AccordionContent>
</template>

<style scoped>
.accordion-content {
  overflow: hidden;
}
.accordion-content[data-state='open'] {
  animation: slideDown 300ms ease-out;
}
.accordion-content[data-state='closed'] {
  animation: slideUp 300ms ease-out;
}

@keyframes slideDown {
  from {
    height: 0;
  }
  to {
    height: var(--radix-accordion-content-height);
  }
}

@keyframes slideUp {
  from {
    height: var(--radix-accordion-content-height);
  }
  to {
    height: 0;
  }
}
</style>
